import { render } from "./DashboardActionItems.vue?vue&type=template&id=4651635d&scoped=true&lang=pug"
import script from "./DashboardActionItems.vue?vue&type=script&lang=js"
export * from "./DashboardActionItems.vue?vue&type=script&lang=js"

import "./DashboardActionItems.vue?vue&type=style&index=0&id=4651635d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4651635d"]])

export default __exports__